import Box from './box.svg';
import Code from './code.svg';
import Generator from './generator.svg';
import Keychain from './keychain.svg';
import Material from './material.svg';
import Puzzle from './puzzle.svg';

export default {
  Box,
  Code,
  Generator,
  Keychain,
  Material,
  Puzzle,
};
